module.exports = __webpack_public_path__ + "img/清单库@3x.png";